import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {RouterOutlet} from "@angular/router";
import {AsideNavComponent} from "./aside-nav/aside-nav.component";
import {NavbarComponent} from "./navbar/navbar.component";
import {SafeZoneComponent} from "./safe-zone/safe-zone.component";
import { AsideService, AsideState } from '../../core/states/aside-service.service';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    AsideNavComponent,
    NavbarComponent,
    SafeZoneComponent
  ],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.css'
})
export class DashboardLayoutComponent {

  isCollapsed = false;
  asideState!: AsideState
  menuState:string = 'out';
  mobileMenuOpen: boolean = false;
  private destroyRef = inject(DestroyRef);

  constructor(public asideService: AsideService){
    this.asideService.asideState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: AsideState) => {
          this.asideState = data;
        }
      });

    this.asideService.movileMenuOpenState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (open: boolean) => {
          this.mobileMenuOpen = open;
          this.menuState = open ? 'in' : 'out';
        }
      });
  }

  changeAsideToFull(){
    this.asideService.setFullMenu();
  }

}
